import { type FocusEvent, createContext } from 'react';

import type { FormControlState } from '../../core/types/form-control-state.js';

type RadioGroupContextType = {
  /** The name of the radio group. */
  name?: string;
  /** Whether the radio group is invalid. */
  hasError?: boolean;
  /** The currently selected value. */
  value: string | undefined | null;
  /** Whether the radio group is disabled. */
  isDisabled?: boolean;
  /** Whether the radio group is aria-disabled. */
  ariaDisabled?: boolean;
  /** Whether the radio group is readOnly. */
  readOnly?: boolean;
  /**
   * Whether the radio group is required.
   * @defaultValue false
   * */
  required?: boolean;
  /** Handler that is called when the value of the group changes. */
  onChange?: (value: string, event?: FocusEvent<HTMLInputElement>) => void;
  /** Describes an enhanced representation of a control validity state and hints about its error for the end user. */
  controlState?: FormControlState;
};

/** Context describing the state of a RadioGroup */
export const RadioGroupContext = createContext<
  RadioGroupContextType | undefined
>(undefined);
